<template>
  <div class="aaaa">
      <p>{{ username }}</p>
  </div>
</template>

<style lang="scss" scoped>
    @import "../scss/scss";
</style>

<script>
    export default {

      data() {
          return {
              username:'cccccccc'
          }
      },
    }
</script>



// WEBPACK FOOTER //
// src/page/scss.vue